import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Translate, I18n } from 'react-redux-i18n'
import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'
import Divider from 'material-ui/Divider'
import copy from 'copy-to-clipboard'
import _ from 'lodash'
import ReactTable from 'react-table'
import 'react-table/react-table.css'

import Loading from 'components/loading'
import { getPromoTokensCode } from 'modules/users/current/promotokens/code'
import { getPromoTokensBalance } from 'modules/users/current/promotokens/balance'
import {
  getPromoTokensAddress,
  generatePromoTokensAddress
} from 'modules/users/current/promotokens/address'
import { updateCurrentUser } from 'modules/users/current'
import { togglePasswordDialog } from 'modules/users/current/passwords'
import { getSecrets, setStage } from 'modules/users/otp'
import { getRefferals, setSearch } from 'modules/users/current/referral_users'
import Group from './group'
import Submit from 'containers/pages/users/submit'
import ChangePassword from './change_password'
import ReferralLink, { social_share_button_tag } from '../referral_link'
import Enable2faStage1 from './enable2fa_stage1'
import Enable2faStage2 from './enable2fa_stage2'
import Disable2fa from './disable2fa'
import BackupCodes from './backup_codes'
import RegenerateBackupCodes from './regenerate_backup_codes'
import parametersSelector from 'selectors/parameters'
import currentUserSelector from 'selectors/current_user'
import errorsSelector from 'selectors/errors'
import referralsSelector from 'selectors/referrals'
import jsonSelector from 'selectors/json'

const ProfileEdit = ({
  generatePromoTokensAddress,
  getSecrets,
  setStage,
  getRefferals,
  setSearch,
  current_user,
  config_parameters,
  promo_token,
  promo_token_balance,
  promo_token_address,
  referrals,
  abilities,
  loading
}) => (
  <div>
    <Grid container>
      <Grid item sm={12} xs={12}>
        <h2>{I18n.t('profile.h')}</h2>
        <Grid container>
          <Grid item xs={12}>
            <ProfileEditReduxForm />
          </Grid>

          <Grid item xs={12}>
            <Divider light />
          </Grid>
          <Grid item xs={12}>
            <ReferralLink />
            {config_parameters['referral.social_share_buttons'] &&
              social_share_button_tag(config_parameters['site.og.title'], {
                url: current_user.referral_link,
                allow_sites: config_parameters['referral.social_share_buttons']
              })}
            <br />
          </Grid>

          {abilities.can_be_used_promo_token && (
            <React.Fragment>
              <Grid item xs={12}>
                <Divider light />
              </Grid>
              <Grid item xs={12}>
                <Loading active={loading} />
                <h4>Your Promo Token address (balance: {promo_token_balance})</h4>
                {promo_token.code && (
                  <Translate
                    value="profile.promocodes.promotokens.description_html"
                    promotoken_code={promo_token.code}
                    dangerousHTML
                  />
                )}
                <Grid container className="promo-token-address" spacing={0}>
                  <Grid item xs={10}>
                    <p id="promo-token-address-box">
                      {promo_token_address ? promo_token_address.payment_address : ''}
                    </p>
                  </Grid>
                  <Grid item xs={2}>
                    {!promo_token_address ? (
                      <Button
                        id="get-promo-token-address"
                        onClick={() => generatePromoTokensAddress()}
                      >
                        Get Address
                      </Button>
                    ) : (
                      <Button
                        id="promo-token-address-copy-link"
                        onClick={() => copy(promo_token_address.payment_address)}
                      >
                        {I18n.t('referral.copy')}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </React.Fragment>
          )}

          <Grid item xs={12}>
            <Divider light />
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <h4>2-Step Verification</h4>
                <p className="text-justify">
                  Applications for generating 2-step verification codes allow you to receive codes
                  even without connecting to the network and cellular communications. Use any
                  application to generate 2-step verification codes. For example, Google
                  Authenticator.
                </p>
                <Grid container>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Button
                      raised
                      color="accent"
                      id="btn-switch-2fa"
                      className="wide"
                      onClick={() =>
                        current_user.otp_required_for_login
                          ? setStage('disable2fa')
                          : getSecrets() && setStage('enable2fa_stage1')
                      }
                    >
                      {current_user.otp_required_for_login ? 'Disable 2FA' : 'Enable 2FA'}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Button
                      raised
                      color="contrast"
                      id="btn-regenerate-backup-codes"
                      className="wide btb-bg-color-black"
                      disabled={!current_user.otp_required_for_login}
                      onClick={() => setStage('regenerate_backup_codes')}
                    >
                      Regenerate backup codes
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              {(referrals.loading === undefined || referrals.total > 0) && (
                <React.Fragment>
                  <Grid item xs={12}>
                    <Divider light />
                  </Grid>
                  <Grid item xs={12}>
                    <div id="referrals-table" className="investment-table">
                      <ReactTable
                        {...referrals}
                        manual
                        sortable={false}
                        onPageChange={page => setSearch({ page })}
                        onPageSizeChange={(per_page, page) => setSearch({ per_page, page })}
                        onFetchData={state =>
                          !referrals.loading &&
                          getRefferals({
                            ...referrals.search,
                            per_page: state.pageSize,
                            page: state.page + 1
                          })
                        }
                        className="-striped"
                      />
                      <div className="pagination-per-page text-center">
                        <br />
                        Total <span className="count">{referrals.total}</span>
                      </div>
                    </div>
                  </Grid>
                </React.Fragment>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
    <ChangePassword />
    <Enable2faStage1 />
    <Enable2faStage2 />
    <Disable2fa />
    <BackupCodes />
    <RegenerateBackupCodes />
  </div>
)

const ProfileEditForm = ({
  submitting,
  handleSubmit,
  togglePasswordDialog,
  current_user,
  errors,
  abilities
}) => (
  <form className="form-horizontal" onSubmit={handleSubmit}>
    {!_.isEmpty(errors) &&
      _.map(errors, (arr, attribute) =>
        _.map(arr, (msg, index) => (
          <div
            key={`${attribute}${index}`}
            className="alert alert-dismissible alert-danger"
            style={{ marginBottom: '5px' }}
          >
            <p>
              — <Translate value={attribute} /> {msg}
            </p>
          </div>
        ))
      )}
    <fieldset>
      <Field
        name="name"
        type="text"
        component={Group}
        label={I18n.t('users.common.name')}
        errors={errors}
      />
      <Field
        name="middle_name"
        type="text"
        component={Group}
        label={I18n.t('users.common.middle_name')}
        errors={errors}
      />
      <Field
        name="last_name"
        type="text"
        component={Group}
        label={I18n.t('users.common.last_name')}
        errors={errors}
      />
      <Field
        name="email"
        type="email"
        disabled
        component={Group}
        label={I18n.t('users.common.email')}
        errors={errors}
      />
      <Field
        name="phone"
        type="text"
        component={Group}
        label={I18n.t('users.common.phone_number')}
        errors={errors}
      />
      {abilities.can_input_eth_wallet && (
        <Field
          name="eth_wallet"
          type="text"
          placeholder={I18n.t('activerecord.attributes.user.eth_wallet')}
          helperText={I18n.t('profile.eth_wallet_helper_text')}
          component={Group}
          label={I18n.t('activerecord.attributes.user.eth_wallet')}
          errors={errors}
        />
      )}
      {abilities.can_input_btc_wallet && (
        <Field
          name="btc_wallet"
          type="text"
          placeholder={I18n.t('activerecord.attributes.user.btc_wallet')}
          component={Group}
          label={I18n.t('activerecord.attributes.user.btc_wallet')}
          errors={errors}
        />
      )}
      <Grid container className="form-group-mui">
        <Grid item xs={12}>
          <Grid container justify="center">
            <Grid item md={6} sm={12} xs={12}>
              <Submit value={I18n.t('profile.submit')} disabled={submitting} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {!current_user.uses_default_password && (
        <Grid container className="form-group-mui">
          <Grid item xs={12}>
            <Divider light />
          </Grid>
          <Grid item xs={12}>
            <Grid container justify="center">
              <Grid item md={6} sm={12} xs={12}>
                <Button
                  raised
                  color="primary"
                  className="wide"
                  id="button-for-change-pasword"
                  onClick={() => togglePasswordDialog()}
                >
                  {I18n.t('profile.change_password')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </fieldset>
  </form>
)

const ProfileEditWalletsForm = ({
  submitting,
  handleSubmit,
  togglePasswordDialog,
  current_user,
  errors,
  abilities
}) => (
  <form className="form-horizontal" onSubmit={handleSubmit}>
    {!_.isEmpty(errors) &&
      _.map(errors, (arr, attribute) =>
        _.map(arr, (msg, index) => (
          <div
            key={`${attribute}${index}`}
            className="alert alert-dismissible alert-danger"
            style={{ marginBottom: '5px' }}
          >
            <p>
              — <Translate value={attribute} /> {msg}
            </p>
          </div>
        ))
      )}
    <fieldset>
      {abilities.can_input_eth_wallet && (
        <Field
          name="eth_wallet"
          type="text"
          placeholder={I18n.t('activerecord.attributes.user.eth_wallet')}
          helperText={I18n.t('profile.eth_wallet_helper_text')}
          component={Group}
          label={I18n.t('activerecord.attributes.user.eth_wallet')}
          errors={errors}
        />
      )}
      {abilities.can_input_btc_wallet && (
        <Field
          name="btc_wallet"
          type="text"
          placeholder={I18n.t('activerecord.attributes.user.btc_wallet')}
          component={Group}
          label={I18n.t('activerecord.attributes.user.btc_wallet')}
          errors={errors}
        />
      )}
      <Grid container className="form-group-mui">
        <Grid item xs={12}>
          <Grid container justify="center">
            <Grid item md={6} sm={12} xs={12}>
              <Submit value={I18n.t('profile.submit')} disabled={submitting} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </fieldset>
  </form>
)

class ProfileEditContainer extends Component {
  componentDidMount() {
    const { abilities } = this.props

    if (abilities.can_be_used_promo_token) {
      const { getPromoTokensCode, getPromoTokensBalance, getPromoTokensAddress } = this.props
      getPromoTokensCode()
      getPromoTokensBalance()
      getPromoTokensAddress()
    }
  }

  render() {
    return <ProfileEdit {...this.props} />
  }
}

const promoTokenAddressSelector = state => {
  const json = _.get(state, 'users.current.promotokens.address.json')
  return json && Object.values(json)[0]
}

const mapStateToProps = state => ({
  current_user: currentUserSelector(state),
  initialValues: currentUserSelector(state),
  errors: errorsSelector('users.current.index', 'validation_error')(state),
  config_parameters: parametersSelector(state),
  promo_token: state.users.current.promotokens.code.json || {},
  promo_token_balance: state.users.current.promotokens.balance.json,
  promo_token_address: promoTokenAddressSelector(state),
  referrals: referralsSelector(state),
  abilities: jsonSelector('infos.abilities')(state),
  loading: state.users.current.promotokens.address.loading
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getPromoTokensCode,
      getPromoTokensBalance,
      getPromoTokensAddress,
      generatePromoTokensAddress,
      updateCurrentUser,
      getSecrets,
      setStage,
      getRefferals,
      setSearch,
      togglePasswordDialog
    },
    dispatch
  )

const ProfileEditReduxForm = connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'current_user',
    enableReinitialize: true,
    onSubmit: (props, dispatch, { updateCurrentUser }) => {
      updateCurrentUser(
        _.pick(props, ['name', 'middle_name', 'last_name', 'phone', 'eth_wallet', 'btc_wallet'])
      )
    }
  })(ProfileEditForm)
)

export const ProfileEditWalletsReduxForm = connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'current_user_wallets',
    enableReinitialize: true,
    onSubmit: (props, dispatch, { updateCurrentUser }) => {
      updateCurrentUser(_.pick(props, ['eth_wallet', 'btc_wallet']))
    }
  })(ProfileEditWalletsForm)
)

export default connect(mapStateToProps, mapDispatchToProps)(ProfileEditContainer)



// WEBPACK FOOTER //
// ./src/containers/pages/profile/edit/index.js